import React from "react";
import "../../styles/EventDetails.scss";
import { FaCalendar as FaCalendarRaw } from "react-icons/fa";
import { FaLocationDot as FaLocationDotRaw } from "react-icons/fa6";
import { IoPerson as IoPersonRaw } from "react-icons/io5";
import { FaClock as FaClockRaw } from "react-icons/fa";

const FaCalendar = FaCalendarRaw as React.ElementType;
const FaLocationDot = FaLocationDotRaw as React.ElementType;
const IoPerson = IoPersonRaw as React.ElementType;
const FaClock = FaClockRaw as React.ElementType;

interface Props {
  event: any;
}

const EventDetails: React.FC<Props> = ({ event }) => {
  const formatFullDate = (dateString: string) => {
    if (!dateString) return "TBA";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const formatDateDisplay = (dates: string[] = []) => {
    if (!dates.length) return "TBA";

    const sortedDates = [...dates].sort(
      (a, b) => new Date(a).getTime() - new Date(b).getTime()
    );

    if (sortedDates.length === 1) {
      return formatFullDate(sortedDates[0]);
    }

    return `${formatFullDate(sortedDates[0])} - ${formatFullDate(
      sortedDates[sortedDates.length - 1]
    )}`;
  };

  const formatTime = (dateString: string) => {
    if (!dateString) return "TBA";
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div className="event-details">
      <img
        src={event.event_image}
        alt={event.event_title}
        className="event-image"
      />
      <h3 className="event-title">{event.event_title}</h3>
      <p className="organizer">by {event.organizer}</p>

      <div className="details">
        <div className="detail-item">
          <FaCalendar className="icon" />
          {/* <span>{formatDateDisplay(event.all_dates || [])}</span> */}
          <span>May 27, 2027 - May 29, 2027</span>
        </div>

        <div className="detail-item">
          <FaClock className="icon" />
          <span>
            {event.all_dates?.length > 0 ? formatTime(event.all_dates[0]) : "TBA"}
          </span>
        </div>

        <div className="detail-item">
          <FaLocationDot className="icon" />
          <span>{event.venue || "TBA"}</span>
        </div>

        <div className="detail-item">
          <IoPerson className="icon" />
          <span>{event.event_rating}</span>
        </div>
      </div>
    </div>
  );
};

export default EventDetails;